module.exports = __webpack_public_path__ + "img/35.c1aedf64.svg";